<template>
  <div class="footer">
    <div class="flex-center">
      <div class="footer-body flex-between">
        <div class="left_bar">
          <div class="flex-between">
            <img class="logo" src="../../static/img/home/lo.png" alt="" @click="linkToHome">
            <div class="verticalLine">
            </div>
            <div>
              <p class="fz14">四川华顺源建设工程有限公司</p>
              <p class="fz10">Sichuan Huashunyuan Construction Project</p>
            </div>
          </div>
          <div>
            <ul class="f_nav flex-start flex-wrap">
              <li class="f_n_list" :class="{'add_f_n_list' :navacitive==index}" v-for="(item,index) in navList"
                :key="index" @click="navroute_func(item.path,index)">
                {{item.title}}
              </li>
            </ul>
          </div>
        </div>
        <!-- 联系我们 -->
        <div class="contact center">
          <p class="c_title">联系我们</p>
          <div class="c_item flex-start line_height34 mt20">
            <img class="c_img" src="../../static/img/home/dian.png" alt="">
            <p>{{contactInfo.tel}}</p>
          </div>
          <div class="c_item flex-start line_height34">
            <img class="c_img" src="../../static/img/home/email.png" alt="">
            <p>{{contactInfo.email}}</p>
          </div>
          <div class="c_item flex-start line_height34">
            <img class="c_img" src="../../static/img/home/di.png" alt="">
            <p>{{contactInfo.address}}</p>
          </div>
        </div>
        <!-- 二维码 -->
        <div class="right">
          <div class="r_top">
            <div class="r_line"></div>
            <div class="r_title">
              <img src="../../static/img/home/Follow us.png" alt="">
            </div>
            <div class="r_name">公众号：{{contactInfo.name}}</div>
          </div>
          <div class="scan">
            <img :src="contactInfo.img" alt="">
            <p>扫一扫关注我们</p>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">Copyright © 2015-2019四川华顺源建设工程有限公司</div>
  </div>
</template>

<script>
import {getAboutUs} from '../../api/apis'
  export default {
    name: 'footer',
    props:{
      navList:Array
    },
    data() {
      return {
        navacitive: 0,
        contactInfo:{},
        setNavactive() {
        let path = this.$route.path;
        switch (path) {
          case '/busines':
            this.navacitive = 1;
            break;
          case '/brief':
            this.navacitive = 2;
            break;
          case '/casecenter':
            this.navacitive = 3;
            break;
          case '/newscenter':
            this.navacitive = 4;
            break;
          case '/talent':
            this.navacitive = 5;
            break;
          case '/concat':
            this.navacitive = 6;
            break;
          case '/':
            this.navacitive = 0;
            break;
          default:
            this.navacitive = 0;
            break;
        }

      }
      }
    },
    mounted(){
      //同步路由
      this.setNavactive();
      //拿关于我们的数据
      getAboutUs().then(res => {
        this.contactInfo = res;
      })
    },
    methods: {
      navroute_func(path, index) {
        this.$router.push({
          'path': path
        });
        this.navacitive = index;
      },
      linkToHome(){
        this.$router.push({'path':'/'});
        this.navacitive=0;
      }
    },
  }
</script>

<style scoped lang='scss'>
  .footer {
    width: 100%;
    height: 366px;
    color: #B9B9B9;
    background-color: #363739;
    font-size: 14px;
  }

  .footer-body {
    height: 306px;
    width: 1200px;

    .left_bar {
      width: 430px;
      margin-top: -74px;
    }
  }

  .verticalLine {
    width: 1px;
    height: 38px;
    background: rgba(255, 255, 255, 1);
  }

  .bottom {
    height: 60px;
    line-height: 60px;
    color: #ffffff;
    background-color: #262729;
    text-align: center;
  }

  .f_nav {
    width: 360rpx;
    margin-left: 70px;
    margin-top: 20px;
    text-align: left;

    .f_n_list {
      width: 90px;
      line-height: 34px;
      cursor: pointer;
    }
  }

  .add_f_n_list {
    color: #fff
  }

  .c_img {
    width: 22px;
    height: 22px;
    margin-right: 18px;
  }

  .c_title {
    line-height: 66px;
    margin-top: -40px;
    font-size: 16px;
    color: #ffffff;
  }

  .right {
    z-index: 2;
    width: 274px;
    height: 384px;
    background-color: #1B5BA0;
    margin-top: -78px;
    color: #ffffff;

    .r_top {
      padding: 47px 31px 0px 31px;
    }

    position: relative;
  }

  .right:before {
    content: '';
    background: url('../../static/img/home/juxing.png') no-repeat;
    position: absolute;
    top: -128px;
    z-index: 2;
    width: 203px;
    height: 119px;
    left: 71px;
  }

  .r_line {
    width: 42px;
    height: 3px;
    background-color: #ffffff;
  }

  .r_title img {
    width: 156px;
    height: 21px;
    padding: 16px 0px;
  }

  .scan {
    text-align: center;

    img {
      height: 160px;
      padding: 21px 0px 18px 0px;
    }

    p {
      font-size: 18px;
    }
  }

  .line_height34 {
    line-height: 34px;
  }

  .flex-center {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  .flex-start {
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .flex-end {
    display: flex;
    justify-content: end;
    align-items: center;
  }

  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex-wrap {
    flex-wrap: wrap
  }

  .logo {
    width: 160px;
    height: 66px;
    cursor:pointer;
  }

  .mt20 {
    margin-top: 20px;
  }

  .fz14 {
    font-size: 14px;
  }

  .fz10 {
    font-size: 10px;
  }
</style>